import { render, staticRenderFns } from "./orderDetailsCard.vue?vue&type=template&id=27fd3048&scoped=true"
import script from "./orderDetailsCard.vue?vue&type=script&lang=js"
export * from "./orderDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./orderDetailsCard.vue?vue&type=style&index=0&id=27fd3048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd3048",
  null
  
)

export default component.exports